import { t } from "@redotech/redo-i18n";
import ArrowsRightIcon from "@redotech/redo-icons/arrows-right_filled.svg";
import { Step } from "@redotech/redo-return-core-common/return-flow";
import { separateLabelsFromModel } from "@redotech/redo-return-core-common/return-flow-step-from-model";
import {
  isSeparateLabelsStepValid,
  SeparateLabelsState,
} from "@redotech/redo-return-core-common/return-flow-step-valid";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const SEPARATE_LABELS = (
  Details: React.ComponentType<StepTypeDetailsProps<SeparateLabelsState>>,
): StepType<SeparateLabelsState, Step.SeparateLabels> => ({
  layout() {
    return BlockLayout.FULL;
  },
  empty: {},

  title: STEP_TYPE_NAMES[Step.SEPARATE_LABELS],

  customTitle: (state) => state.customTitle,

  description: () => {
    return t("Items get their own label");
  },

  Icon: ArrowsRightIcon,
  iconColor: "success",

  Details(props) {
    return <Details {...props} />;
  },

  downstream: () => [],

  maxDownstream: () => 0,

  fromModel: (model) => separateLabelsFromModel(model),

  toModel: (state) => ({
    type: Step.SEPARATE_LABELS,
    customTitle: state.customTitle,
  }),

  valid: (state) => isSeparateLabelsStepValid(state).valid,

  stepDeleted: (state) => state,
});
